import { Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, IconButton, TextField, InputAdornment, Grid } from '@mui/material';
import { Add, Print, PictureAsPdf, Send, Search, Visibility, Cancel } from '@mui/icons-material';
import { retenciones } from '../billingData';

const Retention = () => {
  const getStatusColor = (estado) => {
    switch (estado) {
      case 'emitida': return 'success';
      case 'anulada': return 'error';
      default: return 'default';
    }
  };

  const totalRetencion = retenciones.reduce((acc, doc) => acc + (doc.monto * doc.retencion / 100), 0);

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Comprobantes de Retención
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Documentos de retención de ISR e IVA a proveedores
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} color="primary">
          Nueva Retención
        </Button>
      </Box>

      {/* Stats */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#e3f2fd' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Retenciones</Typography>
              <Typography variant="h4" color="primary">{retenciones.length}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#fff3e0' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Monto Retenido (10%)</Typography>
              <Typography variant="h5" color="warning.main">${totalRetencion.toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card sx={{ backgroundColor: '#e8f5e9' }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary">Total Base</Typography>
              <Typography variant="h5" color="success.main">${retenciones.reduce((a, d) => a + d.monto, 0).toFixed(2)}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filters */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar por cliente, número de documento, NIT..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Desde"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Hasta"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Table */}
      <Card>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Documento</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Fecha</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Cliente</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>NIT</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Base</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">IVA</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Retención %</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="right">Total</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="center">Estado</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }} align="center">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {retenciones.map((doc) => (
                  <TableRow 
                    key={doc.id}
                    sx={{ 
                      opacity: doc.estado === 'anulada' ? 0.6 : 1,
                      '&:hover': { backgroundColor: '#fafafa' }
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {doc.serie}-{doc.correlativo}
                      </Typography>
                    </TableCell>
                    <TableCell>{doc.fecha}</TableCell>
                    <TableCell>{doc.cliente}</TableCell>
                    <TableCell>{doc.nit}</TableCell>
                    <TableCell align="right">${doc.monto.toFixed(2)}</TableCell>
                    <TableCell align="right">${doc.iva.toFixed(2)}</TableCell>
                    <TableCell align="right">{doc.retencion}%</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 500 }}>${doc.total.toFixed(2)}</TableCell>
                    <TableCell align="center">
                      <Chip 
                        label={doc.estado} 
                        color={getStatusColor(doc.estado)} 
                        size="small" 
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton size="small" title="Ver">
                        <Visibility fontSize="small" />
                      </IconButton>
                      <IconButton size="small" title="Imprimir" color="primary">
                        <Print fontSize="small" />
                      </IconButton>
                      <IconButton size="small" title="PDF" color="error">
                        <PictureAsPdf fontSize="small" />
                      </IconButton>
                      <IconButton size="small" title="Enviar Email" color="info">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#fce4ec' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Comprobante de Retención
          </Typography>
          <Typography variant="body2">
            Documento que acredita la retención de Impuesto sobre la Renta (ISR) e IVA realizada a proveedores
            por servicios y bienes sujetos a retención.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Retention;
